import React, { useState } from 'react'
import MonthView from "../../components/Education/calendars/month_view"
import WeekView from "../../components/Education/calendars/week_view"
import YearView from "../../components/Education/calendars/year_view"
import Practice from "../../components/Education/calendars/DayPractice"
import dayjs from 'dayjs'
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/20/solid'

const MainCalendar = () => {
    const [view, setView] = useState('week'); // week, month, year, day
    const [currentDate, setCurrentDate] = useState(dayjs());

    const goToToday = () => setCurrentDate(dayjs());
    const goToPrevious = () => {
        if (view === 'week') setCurrentDate(currentDate.subtract(1, 'week'));
        if (view === 'month') setCurrentDate(currentDate.subtract(1, 'month'));
        if (view === 'year') setCurrentDate(currentDate.subtract(1, 'year'));
        if (view === 'day') setCurrentDate(currentDate.subtract(1, 'day'));

    };
    const goToNext = () => {
        if (view === 'week') setCurrentDate(currentDate.add(1, 'week'));
        if (view === 'month') setCurrentDate(currentDate.add(1, 'month'));
        if (view === 'year') setCurrentDate(currentDate.add(1, 'year'));
        if (view === 'day') setCurrentDate(currentDate.add(1, 'day'));

    };

    const renderDateRange = () => {
        if (view === 'week') {
            const startOfWeek = currentDate.startOf('week').add(1, 'day');
            const endOfWeek = currentDate.endOf('week').add(1, 'day');
            return `${startOfWeek.format('MMM D')} – ${endOfWeek.format('D, YYYY')}`;
        }
        if (view === 'month') {
            return currentDate.format('MMMM YYYY');
        }
        if (view === 'year') {
            return currentDate.format('YYYY');
        }
        if (view === 'day') {
            return currentDate.format('MMMM D, YYYY');
        }
    };
    return (
        <div className='bg-white rounded p-4 shadow'>
            {/* Top Navigation Bar */}
            <div className="flex justify-between items-center border-b pb-4">
                {/* Today button */}
                <button
                    onClick={goToToday}
                    className="px-[20px] py-[10px] rounded border text-black font-semibold text-sm"
                >
                    Today
                </button>

                {/* Center controls */}
                <div className="flex items-center space-x-2">
                    <button
                        onClick={goToPrevious}
                        className="p-1 rounded-full border hover:bg-gray-100"
                    >
                        <ChevronLeftIcon className="h-5 w-5" />
                    </button>
                    <span className="text-sm font-medium">
                        {renderDateRange()}
                    </span>
                    <button
                        onClick={goToNext}
                        className="p-1 rounded-full border hover:bg-gray-100"
                    >
                        <ChevronRightIcon className="h-5 w-5" />
                    </button>
                </div>

                {/* View Switcher */}
                <div className="flex items-center space-x-1 border rounded-[50px] overflow-hidden text-sm">
                    {['year', 'month', 'week', 'day'].map((v,idx) => (
                        <button
                            key={v}
                            onClick={() => setView(v)}
                            className={`px-[15px] py-[10px] 
                                 hover:text-black transition ${view === v ? 'text-black font-semibold' : '' }
                                 ${idx !== 3 ? 'border-r border-gray-300' : ''}
                                 `}
                        >
                            {v.charAt(0).toUpperCase() + v.slice(1)}
                        </button>
                    ))}
                </div>
            </div>

            {/* Calendar Views */}
            <div className="mt-4">
                {view === 'week' && <WeekView currentDate={currentDate} />}
                {view === 'month' && <MonthView currentDate={currentDate} />}
                {view === 'year' && <YearView currentDate={currentDate} />}
                {view === 'day' && <Practice currentDate={currentDate} setCurrentDate={setCurrentDate} />}
            </div>
        </div>
    )
}

export default MainCalendar